import axios from 'axios';
import { AutoSaveConfigurationModel, ConfigurationAuthorizationModel } from '@/types';
import { ConfigurationTreeNodeModel } from '@/types';

const AutoSaveConfigurationApiUrl = 'autosaveconfiguration';

export const AutoSaveConfigurationService = {
  async getAutoSaveConfiguration(): Promise<AutoSaveConfigurationModel> {
    const response = await axios.get(`${AutoSaveConfigurationApiUrl}`);
    return response.data;
  },
  async updateAutoSaveConfiguration(autoSaveConfiguration: AutoSaveConfigurationModel): Promise<void> {
    const response = await axios.put(`${AutoSaveConfigurationApiUrl}`, autoSaveConfiguration);
    return response.data;
  },
  async updateDefaultAutoSaveConfiguration(autoSaveConfiguration: AutoSaveConfigurationModel): Promise<void> {
    const response = await axios.put(`${AutoSaveConfigurationApiUrl}/default`, autoSaveConfiguration);
    return response.data;
  }
};
